/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsersImportRequest } from '../../models/users-import-request';
import { UsersImportResponse } from '../../models/users-import-response';

export interface PostUsersImport$Params {
  'Active-Tenant-Identifier': string;
      body?: UsersImportRequest
}

export function postUsersImport(http: HttpClient, rootUrl: string, params: PostUsersImport$Params, context?: HttpContext): Observable<StrictHttpResponse<UsersImportResponse>> {
  const rb = new RequestBuilder(rootUrl, postUsersImport.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsersImportResponse>;
    })
  );
}

postUsersImport.PATH = '/users-import';
